import React, { useState, useEffect } from "react";
import { Typography, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import FertlizerIcon from "../../assets/Icon/FertilizersIcon.png";
import CustomCard from "../../components/Famer/GenericCard";
import { useNavigate } from "react-router-dom";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";

export default function PesticideFertilizers() {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [selectedFertilizerId, setSelectedFertilizerId] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { showAlert } = useAlert();

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    api
      .get(`/farmer/pesticide_fertilizer/`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };

  const handleEditClick = (fertilizerId) => {
    console.log(fertilizerId);
    navigate(
      `/farmer/create-persicide-fertilizers/?fertilizerId=${fertilizerId}`
    );
  };

  const handleDeleteClick = (fertilizerId) => {
    console.log(fertilizerId);
    setSelectedFertilizerId(fertilizerId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    api
      .delete(`/farmer/pesticide_fertilizer/${selectedFertilizerId}`)
      .then((response) => {
        console.log("Fertilizer deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting fertilizer:", error);
        showAlert("error", "Some issue in deleting the Fertilizer");
      });
  };

  const handleCreateFertilizer = () => {
    window.location.href = "/farmer/create-persicide-fertilizers";
  };
  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: data.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {data.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("Input Supply")}
            </Typography>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
            }}
          >
            {data.map((fertilizer) => (
              <CustomCard
                key={fertilizer.id}
                t={t}
                data={{
                  // [t("Crop Name")]: fertilizer.crop.crop_type,
                  // [t("Crop Type")]: fertilizer.application_type,
                  [t("Product Brand Name")]: fertilizer.product_brand_name,
                  [t("Method")]: fertilizer.method,
                  [t("Quantity")]: fertilizer.quantity,
                  [t("Applied Area")]: fertilizer.area,
                  [t("Application Date")]: fertilizer.application_date,
                }}
                handleEditClick={() => handleEditClick(fertilizer.id)}
                handleDelete={() => handleDeleteClick(fertilizer.id)}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {data.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={FertlizerIcon}
                  alt="My Crops Icon"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />
              </div>
            )}
            <CustomButton onClick={handleCreateFertilizer}>
              {t("Add Fertilizer")}
            </CustomButton>
            {data.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t(
                  "Your pesticide or fertilizer application history be displayed here once you add them."
                )}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this farm?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
